import { render, staticRenderFns } from "./LocationForm.vue?vue&type=template&id=21b6d090&lang=pug"
import script from "./LocationForm.vue?vue&type=script&lang=ts"
export * from "./LocationForm.vue?vue&type=script&lang=ts"
import style0 from "./LocationForm.vue?vue&type=style&index=0&id=21b6d090&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AvailabilityRemark: require('/app/components/generic/AvailabilityRemark.vue').default,Btn: require('/app/components/vantone/Btn.vue').default,NewLocationPickupInput: require('/app/components/generic/NewLocationPickupInput.vue').default,PhoneNumber: require('/app/components/generic/PhoneNumber.vue').default,NewLocationDeliveryInput: require('/app/components/generic/NewLocationDeliveryInput.vue').default,Icon: require('/app/components/vantone/Icon.vue').default,TextInputError: require('/app/components/generic/forms/TextInputError.vue').default,RetrieveQuoteModal: require('/app/components/modals/RetrieveQuoteModal.vue').default,SlideRightTransition: require('/app/components/generic/SlideRightTransition.vue').default})
